import _ from 'lodash'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { getDockedCssForCompLayouts, Component, DockedCompLayout } from '@wix/thunderbolt-becky-root'
import { PopupContainerCSSVars, PopupContainerDefinition } from './PopupContainer'
import { getFillLayersCSSVars } from '../../core/mappers/FillLayers/FillLayers.utils'

const getDockedLayout = (compId: string, compLayout: Component['layout']): DockedCompLayout => {
	return {
		id: compId,
		left: compLayout.x ?? 0,
		top: compLayout.y ?? 0,
		width: compLayout.width ?? 0,
		height: compLayout.height ?? 0,
		docked: compLayout.docked ?? {},
		isFixed: compLayout.fixedPosition ?? false,
		rotationInDegrees: compLayout.rotationInDegrees ?? 0,
	}
}

export const css = withCompInfo<PopupContainerCSSVars, PopupContainerDefinition>()(
	[
		'compDesign',
		'compProps',
		'experiments',
		'isMobileView',
		'siteColors',
		'viewMode',
		'compId',
		// @ts-ignore - Remove once animations is added to the compInfo
		'animations',
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		'isNonAdaptiveMobile',
		'compLayout',
		// @ts-ignore - Remove once compSingleLayout is added to the compInfo
		'compSingleLayout',
		'hasResponsiveLayout',
	],
	({
		compDesign,
		compProps,
		experiments,
		isMobileView,
		siteColors,
		viewMode,
		compId,
		// @ts-ignore - Remove once animations is added to the compInfo
		animations,
		// @ts-ignore - Remove once isNonAdaptiveMobile is added to the compInfo
		isNonAdaptiveMobile,
		compLayout,
		hasResponsiveLayout,
		// @ts-ignore - Remove once isOneDocMigrated is added to the compInfo
		isOneDocMigrated,
	}) => {
		// this replaces 'getResponsivePopupContainerStructure' functionallity in PopupContainer.carmi.ts
		if (hasResponsiveLayout) {
			return {}
		}
		const backgroundMedia = compDesign?.background || {}
		const fillLayersCss = getFillLayersCSSVars({
			animations,
			backgroundMedia,
			compId,
			compDesign,
			compProps,
			experiments,
			isMobileView,
			isNonAdaptiveMobile,
			siteColors,
			viewMode,
		})

		return isOneDocMigrated
			? {
					...fillLayersCss,
			  }
			: {
					...getDockedCssForCompLayouts(
						getDockedLayout(compId, compLayout),
						_.pick(compProps, [
							'alignmentType',
							'horizontalAlignment',
							'verticalAlignment',
							'horizontalOffset',
							'verticalOffset',
						])
					),
					...fillLayersCss,
			  }
	}
)
